export default __webpack_public_path__ + "static/media/bluecloud.88f5f6d7.svg";